/** Отображаемое имя и ссылки (пакеты в монорепо остаются @maximur/*). */
export const BRAND_NAME = 'ТолькоСвои'

export const BRAND_TAGLINE = 'Знакомства в MAX'

/** Username бота в MAX для deep link `https://max.ru/@…` (без @). Задаётся на проде через Vite. */
export function maxBotUsername(): string {
  const raw = import.meta.env.VITE_MAX_BOT_USERNAME?.trim()
  const v = (raw || 'maximur').replace(/^@/, '')
  return v || 'maximur'
}
